module.exports = __webpack_public_path__ + "static/media/buddy-icon-ci.283084ce.png";